export default __webpack_public_path__ + "resources/icons/d241-1da8.png";